import { alpha } from '@mui/material/styles';
import type { PaletteColor } from '@mui/material/styles/createPalette';

import { nlabteam } from './colors';
import type { ColorPreset } from './index';

const withAlphas = (color: PaletteColor): PaletteColor => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5),
  };
};

export const getPrimary = (preset?: ColorPreset): PaletteColor => {
  switch (preset) {
    case 'nlabteam':
      return nlabteam;
    default:
      console.error('Invalid color preset, accepted values: "nlabteam"".');

      return nlabteam;
  }
};

export const getSecondary = (): PaletteColor => {
  return withAlphas({
    lightest: '#4dd0e1',
    light: '#00bcd4',
    main: '#498cae',
    dark: '#0097a7',
    darkest: '#006064',
    contrastText: '#FFFFFF',
  });
};
